
export default class {
  constructor({ element, elements }) {
    this.element = element instanceof HTMLElement ? element : document.querySelector(element)
    this.isVisible = false
    this.selector = elements || {}
    this.elements = {}
    //
   
    for (const [key, selector] of Object.entries(this.selector)) {
      if (selector instanceof HTMLElement || selector instanceof NodeList || selector instanceof Object) {
        this.elements[key] = selector
      } else {
        this.elements[key] = document.querySelectorAll(selector)
        if (this.elements[key].length === 1) {
          this.elements[key] = document.querySelector(selector)
        } else if (this.elements[key].length === 0) {
          this.elements[key] = null
        }
      }
    }


    if ('IntersectionObserver' in window) {
      this.createObserver()
      this.animateOut()
    } else {
      this.animateIn()
    }
  }

  createObserver() {
    this.observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {       
        if (!this.isVisible && entry.isIntersecting) {
          this.animateIn()
        } else {
          this.animateOut()
        }
      })
    })
    this.observer.observe(this.element)
  }

  animateIn() {
    this.isVisible = true
  }

  animateOut() {
    this.isVisible = false
  }

  deleteObserver() {
    // console.log("deleteObserver")
    this.observer.unobserve(this.element)
  }
}
